// Panel qurilmada PIN bilan ishlaganda xodim sessiyasi (p_session) avtomatik qo'shiladigan RPC'lar.
// Yangi RPC guruhi (prefiks) qo'shilsa — shu yerga ham (tests/session-rpc.test.ts tekshiradi).
export const SESSION_RPC = /^(app_me|mgr_|rpt_|stk_|fin_|adv_)/;
